export type AlertGroupMetaType = 'alert_conversation' | 'workflow_group';

/**
 * @deprecated Prefer the AlertGroupMetaType union, as this object will be deprecated in the future.
 */
export const AlertGroupMetaTypes: { [key: string]: AlertGroupMetaType } = {
  ALERT_CONVERSATION: 'alert_conversation',
  WORKFLOW_GROUP: 'workflow_group',
} as const;
